// extracted by mini-css-extract-plugin
module.exports = {"carousel":"styles_carousel__ONwzX","pulse":"styles_pulse__5VH8k","jump":"styles_jump__dxM3Y","wiggle":"styles_wiggle__DkLro"};